module.exports = __webpack_public_path__ + "static/media/Bayesian.af700aca.pdf";